import React from 'react';
import Responsive from 'react-responsive';

export function Desktop(props) {
  return <Responsive {...props} minWidth={768} />;
}
export function Tablet(props) {
  return <Responsive {...props} minWidth={768} maxWidth={991} />;
}
export function HeaderMobile(props) {
  return <Responsive {...props} maxWidth={799} />;
}
export function HeaderDesktop(props) {
  return <Responsive {...props} minWidth={800} />;
}
export function Mobile(props) {
  return <Responsive {...props} maxWidth={767} />;
}
export const TabletWidth = 1224;
export function DashboardDesktop(props) {
  return <Responsive {...props} minWidth={1200} />;
}
export function DashboardMobile(props) {
  return <Responsive {...props} maxWidth={1199} />;
}
export function SignUpDesktop(props) {
  return <Responsive {...props} minWidth={768} />;
}
export function SignUpMobile(props) {
  return <Responsive {...props} maxWidth={767} />;
}

export const WP_URL = 'https://promotionwingman.com/wp-json/wp/v2/';
